// utils/crypto.js
import CryptoJS from 'crypto-js';

const SECRET_KEY = 'cipl'; // Your secret key

// Encrypt function
export const encryptData = (data) => {
  try {
    // Convert object to string if needed
    const stringData = typeof data === 'object' ? JSON.stringify(data) : String(data);
    const encrypted = CryptoJS.AES.encrypt(stringData, SECRET_KEY).toString();
    return encrypted;
  } catch (error) {
    console.error('Encryption error:', error);
    return null;
  }
};

// Decrypt function
export const decryptData = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    
    // Try to parse as JSON, if fails return as string
    try {
      return JSON.parse(decrypted);
    } catch {
      return decrypted;
    }
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
};

// Create encrypted URL params
export const createEncryptedParams = (data) => {
  const encrypted = encryptData(data);
  return new URLSearchParams({ data: encrypted }).toString();
};

// Decrypt URL params
export const getDecryptedParams = (urlSearchParams) => {
  const encryptedData = urlSearchParams.get('data');
  if (!encryptedData) return null;
  return decryptData(encryptedData);
};